module.exports = __webpack_public_path__ + "static/5b7967ee-0b1e-4c2b-901b-3683b08bc425-160.7a9bf26a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-nicholas-rotherfield-greys/5b7967ee-0b1e-4c2b-901b-3683b08bc425-160.jpg
// module id = 1192
// module chunks = 168707334958949